export default "__VITE_ASSET__B4akdSn2__"